/**
 * package: com.inq.addons
 * object: salesforce
 *
 * @description Start Salesforce chat inside tcChat window. Salsforce chat can be engaged from Virtual Agent.
 * This function is for customers who used Nuance VA but still use Salesforce Live Chat.
 * This is Single instance object in system.
 * @see RTDEV-21335
 *
 * SF chat start button example;
 * <code><a id="liveagent_button_online_573o00000008T0d" href="javascript://Chat" style="display: none;" onclick="window.inqFrame.Salesforce.startChat()">Click here to chat with someone now</a>Live Chat Message</code>
 *
 * Requirement: Skin mxml file configuration
 <code>
 e.g. {
		"deploymentURL": "https://c.la3-c1-was.salesforceliveagent.com/content/g/js/35.0/deployment.js",
		"instanceURL": "https://d.la3-c1-was.salesforceliveagent.com/chat",
		"deploymentid": "572o00000008SFJ",
		"organizationid": "00Do0000000eYxt",
		"license": "573o00000008T0d",
		"containerName": "nonInqChatWindow",
		"keepPreviousChat": false,
		"transcriptLabel": "conversation\n",
		"ninaFailConnectMsg": "Click here to chat with a live agent now."
	}
 </code>
 */
com.inq.addons.Salesforce = (function () {

	var StatusEnum = {
		NOT_INITIATED: 'not_initiated',
		INITIATED: 'initiated',
		LOADING: 'loading',
		LOADED: 'loaded',
		PREPARED: 'prepared',
		STARTED: 'started',
		ENDED: 'ended'
	};

	var NINA_FAIL_CONNECT_DEFAULT_MSG = "Click here to chat with a live agent now.";

	var topWindow = null;
	var status = StatusEnum.NOT_INITIATED;
	var isEnabled = false;
	var config = {};
	var script = null;
	var divsub = null;

	/** @type {boolean} */
	var customerRequestedChat = false;

	var init = function (enable) {
		if (isEnabled === false && enable === true) {
			isEnabled = true;
			config = com.inq.utils.Util.getConfig("salesforcechatsupport", {});
			if (config.license && config.deploymentid && config.organizationid && config.instanceURL) {
				if (!config.containerName) {
					config.containerName = "mediumChatDiv";
				}
				if (!config.transcriptLabel) {
					config.transcriptLabel = "VA Transcript\n";
				}
				if (!config.title) {
					config.title = "Salesforce Content";
				}
				status = StatusEnum.INITIATED;
			} else {
				log.error("salesforcechatsupport is not correctly configured in skin", "init");
			}
		}
	};

	var getStatus = function() {
		return status;
	};

	/**
	 * Wraps the text with tags necessary for agent transcript message
	 * @param {string} text to wrap
	 * @returns {string}
	 */
	var createStartChatMsg = function (text) {
		var conf = com.inq.utils.Util.getConfig("salesforcechatsupport", {});

		text = text || conf.ninaFailConnectMsg || NINA_FAIL_CONNECT_DEFAULT_MSG;

		return "<span><div onclick=\"window.inqFrame.Application.sendVALinkClicked(event);\">" +
			      "<a onclick=\"window.inqFrame.Salesforce.startChat()\" ontouchend=\"window.inqFrame.Salesforce.startChat()\">" +
			         text +
			      "</a>" +
			   "</div></span>";
	};

	/**
	 * This method is called by a message handler
	 * When called, it calls init and prepare. Loading salesforce javascript
	 * @param {string} chatText
	 * @param {boolean} forceToConnect
	 * @param {function} callback if being called with first argument defined, it's an error otherwise it's successful
	 * @returns {string}
	 */
	var scanMessage = function (chatText, forceToConnect, callback) {
		callback = callback || function() {};

		if (forceToConnect) {
			chatText = createStartChatMsg();
		}

		if (chatText.indexOf('onclick="window.inqFrame.Salesforce.startChat(') >= 0) {
			init(true);
			prepare(chatText, function(e){
				if (e) {
					log.error("SF failed: " + e, "scanMessage");
				} else {
					log.info("SF chat is ready", "scanMessage");
				}

				callback(e);
			});
		} else {
			callback("chatText does not contain 'startChat' method");
		}
		return chatText;
	};

	var prepare = function (chatText, callback) {
		callback = callback || function() {};

		if (status !== StatusEnum.INITIATED) {
			var errorMessage = "SalesForce is not inited or already prepared";
			log.error(errorMessage, "prepare");
			callback(errorMessage);
			return;
		}

		var myRe = /.*onclick="window.inqFrame.Salesforce.startChat\('(.*?)'\).*/g;
		var myArray = myRe.exec(chatText);
		if(myArray && myArray.length === 2){
			config.license = myArray[1];
		}
		/* _laq is SalesForce Live Chat Specification */
		topWindow = window.top;
		if (!topWindow._laq) {
			topWindow._laq = [];
		}

		loadScriptAsync('salesforceDeploymentScript', config.deploymentURL, afterLoad, topWindow);

		/**
		 * Callback executed when Salesforce javascript is loaded successfully
		 */
		function afterLoad() {
			status = StatusEnum.LOADED;
			// Build transcript to send to a SF Live Agent so an agent knows a customer's interest
			var cw = com.inq.flash.client.chatskins.SkinControl.cw;
			var transcript = "";
			try {
				for (var i = 0; i < cw.arrayTranscripts.length; i++) {
					if (cw.arrayTranscripts[i].MsgType == 1 || cw.arrayTranscripts[i].MsgType == 2) {
						transcript += cw.arrayTranscripts[i].Id + ": " + cw.arrayTranscripts[i].Msg + "\n";
					}
				}
			} catch (err) { /* Ignore - no transcript sent to Live Agent */
			}

			executeCustomData(chatText, transcript);

			try {
				topWindow.liveagent.init(config.instanceURL, config.deploymentid, config.organizationid);
				topWindow.liveagent.enableLogging();
				topWindow._laq.push(function () {
					try {
						topWindow.liveagent.showWhenOnline(config.license, com.inq.ui.Container._getElementById("liveagent_button_online_" + config.license,topWindow.document));
					} catch (err) {
						log.error("fail to change SF start button with error: " + err.getMessage(), "prepare");
					}
				});
				topWindow.liveagent.addButtonEventHandler(config.license, function (e) {
					if (e === topWindow.liveagent.BUTTON_EVENT.BUTTON_AVAILABLE && status === StatusEnum.LOADED) {
						status = StatusEnum.PREPARED;

						if (customerRequestedChat) {
							showChat();
						}
					}
				});
				callback();
			} catch (errInit) {
				log.error("Error while initiating SF Live Agent Chat with error-" + errInit.getMessage(), "prepare");
				endChat();
				callback("Failed to setup SalesForce liveagent");
			}
		}

		//for requiring a script loaded asynchronously.
		function loadScriptAsync(id, src, callback, myWindow) {
			if (com.inq.ui.Container._getElementById(id,myWindow.document) == null) {
				script = myWindow.document.createElement('script');
				script.id = id;
				script.src = src;
			}

			if (callback !== null) {
				if (script.readyState) { // IE, incl. IE9
					script.onreadystatechange = function () {
						if (script.readyState === "loaded" || script.readyState === "complete") {
							script.onreadystatechange = null;
							callback();
						}
					};
				} else {
					script.onload = function () { // Other browsers
						callback();
					};
				}
			}

			status = StatusEnum.LOADING;
			com.inq.ui.Container._getElementByTN('head', myWindow.document)[0].appendChild(script);
		}

		/**
		 * data-custom attribute contains array of arrays containing json which can be used as function call.
		 * [ { "funName": "fname1", "arguments": [] } ] can be converted to liveagent.fname1.apply(liveagent, arguments);
		 * [ { "funName": "fname1", "arguments": [] }, { "funName": "fname1", "arguments": [] } ] can be converted to
		 *        liveagent.fname1.apply(liveagent, arguments).fname1.apply(liveagent, arguments);
		 *
		 * value example
		 '[' +
		 '[ { "funName": "fname1", "arguments": [] } ],' +
		 '[ { "funName": "fname1", "arguments": [] }, { "funName": "fname1", "arguments": [] } ]' +
		 ']'
		 * @param chatText - text line.
		 */
		function executeCustomData(chatText, transcript) {
			var patt = /data-custom="(.*?)"/;
			var custArgsObj;
			if (patt.test(chatText)) {
				try {
					var custArgsJson = patt.exec(chatText);
					custArgsObj = JSON.parse(decodeURIComponent(custArgsJson[1]));

					for (var i = 0; i < custArgsObj.length; i++) {
						var rootObj = topWindow.liveagent;
						var element = custArgsObj[i];
						try {
							element.forEach(function (liveFunElement) {
								// _TRANSCRIPT_ is keyword Nina sends and CI replaces with real keyword.
								for (var ia = 0; ia < liveFunElement.arguments.length; ia++) {
									if (liveFunElement.arguments[ia] === "_TRANSCRIPT_") {
										liveFunElement.arguments[ia] = transcript;
									}
								}
								rootObj = rootObj[liveFunElement.funName].apply(rootObj, liveFunElement.arguments);
							});
						} catch (err) {
							log.error("Error: executeCustomData " + chatText, "prepare.executeCustomData");
						}
					}
				} catch (errTop) {
					log.error("Error: while getting custArgsObj " + chatText, "prepare.executeCustomData");
				}
			}
		}
	};

	/**
	 * startChat - is used to display the salesforce chat or to set 'start' property to 'true'
	 * to display the salesforce chat after salesforce chat has been prepared.
	 *
	 * @param {string} argLicense
	 */
	var startChat = function (argLicense) {
		log.info("SF Live Agent engagement is started", "startChat");

		/* License can be overwritten through startChat function call in <a> onClick event */
		if (argLicense) {
			config.license = argLicense;
		}

		if (status === StatusEnum.LOADING || status === StatusEnum.LOADED) {
			customerRequestedChat = true;
		} else if (status === StatusEnum.PREPARED) {
			showChat();
		} else {
			log.error("Error: while starting chat", "startChat");
		}
	};

	/**
	 * Displays a salesforce chat if it has been prepared before
	 */
	var showChat = function () {
		if (status === StatusEnum.PREPARED) {
			setBtnVisible(false);

			addIFrameForNonInqChatToTcChat();

			if (config.keepPreviousChat) {
				com.inq.flash.client.chatskins.SkinControl.hideInput();
			} else {
				// In case with SalesForce and VA here we close chat faster than
				// send back to VA message about click on start chat link. So
				// here we add 200ms timeout to give our system a chance to send
				// message about to click.
				setTimeout(com.inq.flash.client.chatskins.SkinControl.closeThroughSalesforceChat, 200);
			}

			topWindow.liveagent.startChatWithWindow(config.license, config.containerName);
			log.info("liveagent.startChatWithWindow is called", "startChat");

			bindListeners();
			status = StatusEnum.STARTED;
		} else {
			log.error("Error: while showing chat", "showChat");
		}

		/**
		 * Adds listeners for setting up connection between our and salesfoce chats
		 */
		function bindListeners() {
			if (topWindow.addEventListener) {
				topWindow.addEventListener("message", receiveMessage, false);
			} else if (topWindow.attachEvent) {
				topWindow.attachEvent("onmessage", receiveMessage);
			}
		}

		/**
		 * This function was implemented to listen to the "message" event from SalesForce chat to call necessary
		 * method by message text. It is used for:
		 * "exitChat"       - exit chat
		 * "minimizeChat"   - minimize chat
		 * "expandChat"     - expand chat
		 * "shrinkChat"     - shrink chat
		 *
		 * @param {MessageEvent} event
		 */
		function receiveMessage(event) {
			var message = event.data;

			if (message === "exitChat") {
				endChat();
			} else if (message === "minimizeChat") {
				com.inq.flash.client.control.MinimizeManager.actionMinimize();
			} else if (message === "expandChat") {
				com.inq.flash.client.chatskins.ChatTextFocusMonitor.expandChat();
			} else if (message === "shrinkChat") {
				com.inq.flash.client.chatskins.ChatTextFocusMonitor.shrinkChat();
			}
		}

		/**
		 * This function will be used in InqFramework.js
		 */
		function addIFrameForNonInqChatToTcChat() {
			var iframe;
			var tcChatSkin = com.inq.ui.Container._getElementById('tcChat_Skin',topWindow.document);

			divsub = topWindow.document.createElement("DIV");
			divsub.id = "nonInqChatDiv";
			divsub.style.cssText = 'position:absolute;top:0px;left:0px;width:100%;height:100%;opacity:1;z-index:9999999;background:#000;';

			iframe = "<IFRAME id='" + config.containerName + "' "
				+ "NAME=\"" + config.containerName + "\" "
				+ "title=\"" + config.title + "\" "
				+ "width=\"100%\" height=\"100%\""
				+ "></IFRAME>";
			divsub.innerHTML = iframe;

			tcChatSkin.appendChild(divsub);
		}

		/**
		 * setBtnVisible - is used to manage visibility state of the liveAgent button.
		 *
		 * @param {boolean} visible
		 */
		function setBtnVisible(visible) {
			var display = visible ? "block" : "none";
			var btnChat = com.inq.ui.Container._getElementById('liveagent_button_online_' + config.license, topWindow.document);
			if (btnChat) {
				btnChat.style.display = display;
			}
		}
	};

	/**
	 * endChat - is used to close Salesforce chat
	 */
	var endChat = function () {
		if (config.keepPreviousChat) {
			com.inq.flash.client.chatskins.SkinControl.showInput();
		} else {
			com.inq.flash.client.chatskins.SkinControl.actionCloseChat();
		}

		reset();
	};

	/**
	 *  Resets variables to default state and removes scripts
	 */
	var reset = function () {

		if (!isEnabled) {
			return;
		}

		topWindow = topWindow || window.top;

		isEnabled = false;
		status = StatusEnum.NOT_INITIATED;
		customerRequestedChat = false;

		topWindow.liveagent = null;
		topWindow.liveAgentDeployment = null;

		if (script) {
			script.parentNode && script.parentNode.removeChild(script);
			script = null;
		}

		if (divsub) {
			divsub.parentNode && divsub.parentNode.removeChild(divsub);
			divsub = null;
		}
	};

	var log = {
		error: function (message, methodName) {
			com.inq.flash.client.control.FlashPeer.logErrorToServer("SalesForce." + methodName + ": " + message);
		},
		info: function (message, methodName) {
			com.inq.flash.client.control.FlashPeer.logInfoToServer("SalesForce." + methodName + ": " + message);
		}
	};

	/**
	 * Returns true if chat is started
	 *
	 * @return {boolean}
	 */
	var isStarted = function () {
		return status === StatusEnum.STARTED;
	};

	/**
	 * Publish API to parent window.
	 */
	com.inq.utils.Util.publish("window.inqFrame.Salesforce.prepare", prepare);
	com.inq.utils.Util.publish("window.inqFrame.Salesforce.startChat", startChat);
	com.inq.utils.Util.publish("window.inqFrame.Salesforce.endChat", endChat);

	return {
		name: "com.inq.addons.Salesforce",
		init: init,
		reset: reset,
		getStatus: getStatus,
		scanMessage: scanMessage,
		prepare: prepare,
		startChat: startChat,
		isStarted: isStarted,
		endChat: endChat
	}
})();
